export default { 
  name : 'Boat Name',
  objectType : 'boat',
  valueType : 'string',
  displayName : 'Boat Name',
  get : () => null
}
